import { getExcelWorksheet } from './common'
import { allColumns, getColumnLayout, getColumnsCount } from './commonStatementFunctions'

function getCellValue(worksheet, cell) {
  const cellValue = worksheet.getCell(cell).value
  if (cellValue === null || cellValue === undefined) return 0
  if (typeof cellValue === 'object' && cellValue.result !== undefined) return cellValue.result
  return cellValue
}

export async function sumStatement(file, agreement) {
  const worksheet = await getExcelWorksheet(file)
  const columnsCount = getColumnsCount(agreement)
  const layout = getColumnLayout(columnsCount)
  const totalRow = agreement.coopGroups.length + 3

  const turnoverCol = allColumns[layout.totalGeneralIdx]

  const columns = agreement.columns || []
  const sortedColumns = [...columns].sort((a, b) => a.position - b.position)

  const columnDiscounts = layout.rfdBlocks.map((block, idx) => {
    const colName = sortedColumns[idx]?.name || `Colonne ${idx + 1}`
    const totalCol = allColumns[block.totalIdx]
    return {
      name: colName,
      value: getCellValue(worksheet, `${totalCol}${totalRow}`),
    }
  })

  const totalDiscount = columnDiscounts.reduce((sum, col) => sum + col.value, 0)

  return {
    turnover: getCellValue(worksheet, `${turnoverCol}${totalRow}`),
    totalDiscount,
    columnDiscounts,
  }
}
